import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEnvironmentalReports } from "../../../store/slices/fault-module/environmental-report.slice";
import EnvironmentalReportTableComponent from "./environmental-report-table.component";

const EnvironmentalReportComponent = () => {
  const [chartData, setChartData] = useState<any>([]);

  const dispatch = useDispatch();

  const environmentalReportData = useSelector((state: any) => {
    return state.environmentalReport.environmentalReports;
  });

  const isLoadingEnvironmentalReportData = useSelector((state: any) => {
    return state.environmentalReport.isLoading;
  });

  useEffect(() => {
    if (environmentalReportData?.data?.length) {
      const assetIds = environmentalReportData.data.map(
        (d: any) => d.assetCode
      );

      const hours = environmentalReportData.data.map((d: any) => d.hour);

      // const assetReadings = environmentalReportData.data.map(
      //   (d: any) => d.sensorReading
      // );

      const assetReadings = environmentalReportData?.data?.every((d: any) => d?.sensorReading == null)
      ? null
      : environmentalReportData?.data?.map(
        (d: any) => d?.sensorReading
      );


      setChartData({
        assetIds,
        hours,
        assetReadings,
      });
    } else {
      setChartData({
        assetIds: [],
        hours: [],
        assetReadings: [],
      });
    }
  }, [environmentalReportData]);

  const onRefetchData = (
    tcCode = null,
    siteCode = null,
    blockCode = null,
    reportType = null,
    startDate = null,
    endDate = null,
    asset = null
  ) => {
    dispatch(
      getEnvironmentalReports({
        tcCode,
        siteCode,
        blockCode,
        reportType,
        startDate: startDate,
        endDate: endDate,
        asset,
      })
    );
  };

  return (
    <div>
      <EnvironmentalReportTableComponent
        chartData={chartData}
        onRefetchData={onRefetchData}
        isLoading={isLoadingEnvironmentalReportData}
      />
    </div>
  );
};

export default EnvironmentalReportComponent;
